module.exports = __webpack_public_path__ + "img/family.e7335d54.jpg";